import React from "react";
import { ViewLead } from "./ViewLeadShared";

/** Business lead detail view (`/business-leads/:id/view`). */
function ViewBusinessLead(props) {
  return <ViewLead {...props} type="lead" />;
}

export default ViewBusinessLead;
